import React, { useContext } from "react";
import { Route, Routes } from 'react-router-dom';

import { AppContext} from '../../AppContext';


import PdfDemo from "./PdfDemo";

import '../css/GPTApp.css';
import PdfContracts from "./PdfContracts";


function QPdf() {

    const { userID, userStatus, loading } = useContext(AppContext).contextValue;
    if (loading) {
        return <div></div>;
    }

    return (
            <div>
                <Routes>
                    <Route
                    path="*"
                    element={userStatus === 'demo' ? <PdfDemo /> : <PdfContracts userID= {userID}/>}
                    />
                </Routes>
            </div>
    );
}

export default QPdf; 